export default function useApiError(error) {
  console.log(error)
}
